import * as React from 'react'

import { ArrowLeft } from 'lucide-react'
import { useSiteMetadata } from 'hooks/useSiteMetadata'
import * as styles from './UserVerificationInfo.module.scss'

export const UserVerificationInfo = ({
  email = 'a@gmail.com',
  goToResend,
  goToVerification,
  hideSenderEmail,
}) => {
  const metadata = useSiteMetadata()

  return (
    <div className={styles.formWrapper}>
      <button className={styles.backButton} onClick={goToVerification}>
        <ArrowLeft /> Back
      </button>
      <div className={styles.wrapper}>
        <span className={styles.header}>Didn’t receive an email?</span>
        <div className={styles.content}>
          <b>Follow these steps to ensure</b>
          <div className={styles.listItems}>
            <ol>
              {hideSenderEmail ? (
                <li>Check your spam folder.</li>
              ) : (
                <li>
                  Check your spam. The verification email will be from this:{' '}
                  {metadata.senderEmail || 'placeholder@email.com'}
                </li>
              )}
              <li>
                Make sure you're checking the email that you signed up with
                below:
              </li>
            </ol>
            <span>Email Linked to Your Account *{email}</span>
          </div>
          <button onClick={goToResend} className={styles.resendLink}>
            <span>Still can't find your verification code? Click here.</span>
          </button>
        </div>
      </div>
    </div>
  )
}
